import { render } from "./LayoutSidebar.vue?vue&type=template&id=16255372&scoped=true"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js"

import "./LayoutSidebar.vue?vue&type=style&index=0&id=16255372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16255372"]])

export default __exports__